import { baseApi } from "../app-main/store/baseApi";

export type IncompleteEmbedMediaListingsResponse = {
  listingIds: string[];
};

/**
 * Returns listing IDs that have no video/3D-tour embed media for the
 * authenticated host. Backed by
 * `GET /v2/spaces-v2/listings/embed-media/incomplete`. The owner SSO id is
 * derived from the auth token, so there is no path param. When every listing
 * already has a video the server returns `{ listingIds: [] }`.
 */
export const embedMediaApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getIncompleteEmbedMediaListings: builder.query<
      IncompleteEmbedMediaListingsResponse,
      void
    >({
      query: () => ({
        url: "/v2/spaces-v2/listings/embed-media/incomplete",
      }),
    }),
  }),
});

export const { useGetIncompleteEmbedMediaListingsQuery } = embedMediaApi;
